import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_TEXT,
  PRIMARY_ICON,
  PRIMARY_LINK,
  DARK_TEXTBOX_BACKGROUND,
  PLAIN_ICON,
  LIGHTER_BUTTON_BACKGROUND,
  PRIMARY_BUTTON_BACKGROUND,
} = COLORS;

export const useStyles = makeStyles(() =>
  createStyles({
    boxContainer: {
      '& .MuiOutlinedInput-root': {
        height: '60px',
        borderRadius: '6px',
        backgroundColor: LIGHTER_BUTTON_BACKGROUND,
      },

      '& input': {
        fontSize: '14px',
      },
      transition: '300ms',
      overflow: 'hidden',
      '& .MuiInputBase-input': {
        backgroundPosition: 0,
      },
    },
    checkboxContainer: {
      marginTop: 5,
      '& .MuiFormControlLabel-root': {
        marginTop: -4,
      },
    },
    extraContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '10px 0 8px',
      alignItems: 'center',

      '& a, & span': {
        fontSize: '14px',
      },
      '& a': {
        color: PRIMARY_LINK,
      },
    },
    link: {
      color: PRIMARY_LINK,
      textDecoration: 'none',
    },
    buttonCls: {
      height: '60px !important',
      borderStyle: 'solid',
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
    },
    registerBtn: {
      borderStyle: 'solid',
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
      backgroundColor: PRIMARY_BUTTON_BACKGROUND,
    },
    loginHead: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& span': {},
    },
    loginFooter: {
      marginTop: 40,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& *': {
        fontSize: '14px',
      },
      '& span': {},
    },
    facebookBtn: {
      background: PRIMARY_ICON,
    },
    facebookIcon: {
      position: 'absolute',
      left: 20,
      '& path': {
        fill: PLAIN_ICON,
      },
    },
    googleBtn: {
      fontWeight: 'bold',
      background: PLAIN_ICON,
      color: DARK_TEXT,

      '&:hover': {
        background: PLAIN_ICON,
      },
    },
    googleIcon: {
      fontSize: 20,
      position: 'absolute',
      left: 20,
    },
    input: {
      borderRadius: 8,
      fontWeight: 400,
      '& input': {
        fontSize: 14,
      },
      '& .MuiInputBase-root': {
        paddingLeft: 20,
        borderRadius: 8,
        background: DARK_TEXTBOX_BACKGROUND,
      },

      '& .MuiFormHelperText-root': {
        marginLeft: 0,
      },
    },
    startIcon: {
      fontSize: 20,
      marginRight: 5,
    },
  }),
);
